"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _slatePlugins = require("@udecode/slate-plugins");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isUrl = _interopRequireDefault(require("../../../../utils/isUrl"));
var _excluded = ["children", "element"];
var Link = function Link(_ref) {
  var children = _ref.children,
    element = _ref.element,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({
    href: element.url,
    style: element.style
  }, props), children);
};
var serializableLinkElement = {
  link: {
    component: Link,
    type: _slatePlugins.ELEMENT_LINK,
    isUrl: _isUrl["default"],
    rootProps: {
      className: 'slate-link',
      target: '_blank',
      rel: 'noopener noreferrer'
    }
  }
};
Link.propTypes = {
  children: _propTypes["default"].node,
  attributes: _propTypes["default"].elementType,
  element: _propTypes["default"].shape({
    url: _propTypes["default"].string.isRequired,
    style: _propTypes["default"].string.isRequired
  }).isRequired
};
Link.defaultProps = {
  children: null,
  attributes: []
};
var _default = exports["default"] = serializableLinkElement;